import {UsersState} from '../users/redux/reducer';
import {useAppSelector} from './redux';

export const useUsers = (): UsersState => {
  return useAppSelector(state => state.entities.users);
};
